export const iconHutBotHappy = require('./icon-hutbot-happy.png');
